import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-todo-check-success',
  templateUrl: './todo-check-success.component.svg',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TodoCheckSuccessComponent {}
